import BaseEllipsisMenu from 'components/BaseEllipsisMenu/BaseEllipsisMenu';
import CloseAlertModal from 'features/Weather/features/WeatherAlerts/components/Modals/CloseAlertModal/CloseAlertModal';
import { closeAlertThunk } from 'features/Weather/features/WeatherAlerts/features/AlertList/state/thunks/alertListThunks';
import { setRescAlertUpdateContext } from 'features/Weather/features/WeatherAlerts/features/AlertCreator/state/slices/alertCreatorSlice';
import { createRescAlertUpdateDraft } from 'features/Weather/features/WeatherAlerts/features/AlertCreator/utils/alertCreator.utils';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FaCircleXmark, FaPen } from 'react-icons/fa6';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

/**
 * Shows the actions supported for a user-generated Fusion alert.
 *
 * @param {{ alert: Alert, canEditAlerts?: boolean, canDeleteAlerts?: boolean }} props
 */
const UserGeneratedAlertOptions = ({ alert, canEditAlerts, canDeleteAlerts }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showCancel, setShowCancel] = useState(false);

  return (
    <>
      <BaseEllipsisMenu
        ariaLabel={`Open alert options for ${alert.description}`}
        options={[
          canEditAlerts
            ? {
                component: (
                  <Button
                    type="button"
                    variant="link"
                    className="text-start"
                    onClick={() => {
                      dispatch(
                        setRescAlertUpdateContext({
                          alert,
                          draft: createRescAlertUpdateDraft(alert),
                        }),
                      );
                      navigate('/publicuser/createalert');
                    }}
                  >
                    <span
                      className="d-inline-flex rounded-circle bg-primary p-1 text-white"
                      aria-hidden="true"
                    >
                      <FaPen size={10} />
                    </span>
                    Edit / Update Alert
                  </Button>
                ),
              }
            : null,
          {
            component: (
              <Button
                type="button"
                variant="link"
                className="text-start text-danger"
                disabled={!canDeleteAlerts}
                onClick={() => setShowCancel(true)}
              >
                <FaCircleXmark aria-hidden="true" />
                Cancel Alert
              </Button>
            ),
          },
        ].filter(Boolean)}
      />
      <CloseAlertModal
        show={showCancel}
        alert={alert}
        onClose={() => setShowCancel(false)}
        onConfirm={(notes) => {
          if (!canDeleteAlerts) return;
          dispatch(closeAlertThunk({ alertId: alert.message_id, notes }));
          setShowCancel(false);
        }}
      />
    </>
  );
};

export default UserGeneratedAlertOptions;
